<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/4y8G8Y/tc-custom/9780795338694.jpg?1734321272208" alt="This image is the cover for the book To Be the Best, Emma Harte Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">To Be the Best, Emma Harte Series
      </h1>
      <p class="bookDescription body article font2">
        <b>Emma Harte’s legacy lives on in a “lushly detailed” novel following <i>A Woman of Substance</i> and <i>Hold the Dream</i> from the #1 <i>New York Times</i>–bestselling author (<i>Rave Reviews</i>).</b><br/>  <br/> The heiress to Emma Harte’s international retail empire, Paula McGill O’Neill has grown to fill her legendary grandmother’s shoes and become the woman she has always wanted to be. Coming into her own, she now keeps her grandmother’s vision alive with firm, confident control.<br/>  <br/> But unbeknownst to her, Paula faces threats from every side. Two families watch her carefully, each hoping for their own chance at the reins of power, and an old enemy lurks in the shadows, alert to any sign of weakness. When Paula’s unscrupulous cousin Jonathan returns, even more determined than ever to wrest away everything Paula has fought for, she must marshal all her strength and fortitude to defend her fortune and her family.<br/>  <br/> “A compulsive read.” —<i>Daily Mail</i><br/>  <br/> “Will keep you up till all hours reading just one more chapter before you can bear to turn out the bedside light.” —<i>Prima</i><br/>  <br/> “A host of dramatic subplots continues the amorous, sorrowful and shady doings of the O’Neills and the Kallinskis, two families whose fortunes are entwined with the Hartes.” —<i>Publishers Weekly</i><br/>  <br/> “Readers will happily re-acquaint themselves with the sprawling Harte clan . . . A more than satisfactory sequel to the previous segments of this generational tale, with an ending that promises still more to come.” —<i>Library Journal</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Barbara Taylor Bradford
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      RosettaBooks, LLC
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?57e24178